import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/24/solid';

export default function SidebarNavFooter({
  isFullNavHidden,
  setIsFullNavHidden,
}: {
  isFullNavHidden: boolean;
  setIsFullNavHidden: () => void;
}) {
  return (
    <>
      <button
        type='button'
        className='w-full bg-neutralColor-lighter text-neutralColor-normal px-4 py-2 text-left cursor-pointer hover:bg-neutralColor-lightest hover:text-primaryColor-normal'
        onClick={setIsFullNavHidden}
      >
        {isFullNavHidden ? (
          <ChevronDoubleRightIcon className='h-5 w-5' />
        ) : (
          <div className='flex min-w-0 gap-2 overflow-hidden'>
            <ChevronDoubleLeftIcon className='h-5 w-5 shrink-0' />
            <span className='truncate'>Hide Full Navigation</span>
          </div>
        )}
      </button>
      {!isFullNavHidden && (
        <div className='shrink-0 flex flex-col gap-4 border-t border-gray-200 p-4'>
          <div className='flex items-center shrink-0'>
            <img
              className='h-6 w-auto'
              src='https://assets.seinterminal.com/images/logos/SEIN_Terminal_Logo_Color.png'
              alt='company-logo'
            />
          </div>
          {/* <div className='ml-3 block'>
            <p className='w-60 overflow-hidden text-xs font-medium text-gray-700 group-hover:text-gray-900'>
              &#169; 2023 SEIN Technology Partners.
            </p>
            <p className='w-60 overflow-hidden text-xs font-medium text-gray-500 group-hover:text-gray-700'>
              All Rights Reserved
            </p>
          </div> */}
        </div>
      )}
      {isFullNavHidden && (
        <div className='flex justify-center p-2 border-t border-gray-200'>
          <img className='h-6 w-auto' src='https://assets.seinterminal.com/images/logos/STP_Logo_Color.png' alt='stp-logo' />
        </div>
      )}
    </>
  );
}
